import "core-js/modules/es.array.push.js";
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message-box/style/css'

import { authApi } from './api/auth';
export default {
  name: 'App',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isLoginPage = computed(() => route.name === 'Login');
    const isFullPage = computed(() => route.name === 'DigitalTwinScreen' || route.name === 'MobileNotice' || route.name === 'MobileQuery');
    // 依赖 route.path 以保证登录/退出后重新求值（localStorage 非响应式）
    const isLoggedIn = computed(() => !!route.path && authApi.isLoggedIn());
    const currentUser = computed(() => route.path ? authApi.getCurrentUser() : null);
    const isAdmin = computed(() => {
      const u = route.path ? authApi.getCurrentUser() : null;
      return !!u && u.role === 'admin';
    });
    const activeMenu = computed(() => route.path);
    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm('确认退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        authApi.logout();
        router.push('/login');
      } catch {
        // 取消退出
      }
    };
    const goHome = () => {
      router.push('/');
    };
    const goUsers = () => {
      router.push('/users');
    };
    const goChangePassword = () => {
      router.push('/change-password');
    };
    return {
      isLoginPage,
      isFullPage,
      isLoggedIn,
      currentUser,
      isAdmin,
      activeMenu,
      handleLogout,
      goHome,
      goUsers,
      goChangePassword
    };
  }
};